module.exports = __webpack_public_path__ + "img/5x.513dd47a.png";